import { render } from "./ConfirmMail.vue?vue&type=template&id=40f21ad9&ts=true"
import script from "./ConfirmMail.vue?vue&type=script&lang=ts"
export * from "./ConfirmMail.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\benja\\Desktop\\LolaClean\\Frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__